import { Component, computed, input } from '@angular/core';
import { WorkTimerecordSaldoDto } from '@work-frontend-monorepo/work-rest-api';
import { TranslatePipe } from '@ngx-translate/core';
import { DecimalPipe, NgClass } from '@angular/common';

@Component({
  selector: 'sfg-app-arbeitszeit-stundensaldo',
  templateUrl: './arbeitszeit-stundensaldo.component.html',
  styleUrls: ['./arbeitszeit-stundensaldo.component.scss'],
  standalone: true,
  imports: [DecimalPipe, NgClass, TranslatePipe],
})
export class ArbeitszeitStundensaldoComponent {
  balance = input.required<WorkTimerecordSaldoDto>();

  saldoIsPositive = computed(() => (this.balance().saldo ?? 0) >= 0);
}
